<h1 mat-dialog-title>Set product eligibility</h1>
<div mat-dialog-content class="eligibility-dialog">
  <p class="member-name">{{ memberName }}</p>
  <ng-container *ngIf="data.user">
    <p>{{ data.user.email }}</p>
    <mat-form-field appearance="outline" *ngIf="companies.length">
      <mat-label>Company</mat-label>
      <mat-select [value]="companyId" (selectionChange)="selectCompany($event.value)" [disabled]="loading || saving || companies.length === 1">
        <mat-option *ngFor="let company of companies" [value]="company.id">{{ company.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="companyTeams.length > 1">
      <mat-label>Team</mat-label>
      <mat-select [value]="teamId" (selectionChange)="selectTeam($event.value)" [disabled]="loading || saving">
        <mat-option *ngFor="let team of companyTeams" [value]="team.teamId">{{ team.teamName }}</mat-option>
      </mat-select>
    </mat-form-field>
    <p *ngIf="companyTeams.length === 1">Team: {{ companyTeams[0].teamName }}</p>
  </ng-container>
  <p *ngIf="loading">Loading products...</p>
  <form *ngIf="!loading && context" [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>Products</mat-label>
      <mat-select formControlName="productIds" multiple>
        <mat-option *ngFor="let product of context?.products" [value]="getProductId(product)">
          {{ getProductLabel(product) }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('productIds')?.hasError('required')">Select at least one product.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Eligibility Start Date</mat-label>
      <input matInput type="date" formControlName="startDate">
      <mat-error *ngIf="form.get('startDate')?.hasError('required')">Start Date is required.</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Eligibility End Date</mat-label>
      <input matInput type="date" formControlName="endDate">
      <mat-error *ngIf="form.get('endDate')?.hasError('required')">End Date is required.</mat-error>

    </mat-form-field>
    <p role="alert" *ngIf="form.hasError('invalidDateRange')">End Date must be on or after Start Date.</p>
  </form>
  <app-inlinemessage *ngIf="error" level="error" [message]="error"></app-inlinemessage>
</div>
<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" [disabled]="loading || saving || form.invalid || !context" (click)="save()">
    {{ saving ? 'Saving...' : 'Save' }}
  </button>
</div>
